var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"voucher-bottom-guide"},[(_vm.device === 'ios')?_c(_setup.BottomGuideIos,{attrs:{"id":"bottomGuide"}}):_c(_setup.BottomGuideNormal)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }